/**
 * コモンクラス
 * @constructor
 */
class Consultation {
  constructor() {}
  init() {
    
    //SNSエリア
    if ($('.p-consultation__sns').hasClass('hide')) {
      $('.p-consultation__sns').hide();
    }
    if ($('.p-consultation__sns-list-item--facebook a').attr('href') == 0) {
      $('.p-consultation__sns-list-item--facebook').hide();
    }
    if ($('.p-consultation__sns-list-item--twitter a').attr('href') == 0) {
      $('.p-consultation__sns-list-item--twitter').hide();
    }
    if ($('.p-consultation__sns-list-item--instagram a').attr('href') == 0) {
      $('.p-consultation__sns-list-item--instagram').hide();
    }
    if ($('.p-consultation__sns-list-item--youtube a').attr('href') == 0) {
      $('.p-consultation__sns-list-item--youtube').hide();
    }
    
    //pdfの設定
    if ($('.content-pdf').hasClass('none')) {
      $('.content-pdf.none').html('－');
    }
    
    //linkの設定
    if ($('.content-link').hasClass('none')) {
      $('.content-link.none').html('－');
    }
    
    //センターからのお知らせ
    if ($('.p-consultation__news').hasClass('hide')) {
      $('.p-consultation__news-list').hide();
      $('.p-consultation__news-comment').show();
    }
    
    //セミナーのご案内
    if ($('.p-consultation__seminar').hasClass('hide')) {
      $('.p-consultation__seminar-table').hide();
      $('.p-consultation__seminar-comment').show();
    }
    
    //センターからのお知らせ
    if ($('.p-consultation__businessTrip').hasClass('hide')) {
      $('.p-consultation__businessTrip-table').hide();
      $('.p-consultation__businessTrip-comment').show();
    }
    
    $('.js-accTrigger').on('click',function() {
      $(this).toggleClass('is-active');
      $('.js-accTarget').slideToggle();
      
    })
    
    
    var headerHeight = $(".l-header").height();
    var speed = 500;
//    console.log($(".l-header").height())
    $('a[href^="#"]').click(function () {
      var href = $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top - headerHeight;
      $("html, body").animate({
        scrollTop: position
      }, speed, "swing");
      return false;
    });
    
  }
}
export default Consultation;